
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Container } from "inversify";
import InlineFormTreeselect from "../../../../../../landing/src/molecules/form/InlineFormTreeselect.vue";
import TreeGroup from "../../../components/TreeGroup.vue";
import Loader from "../../../components/Loader.vue";
import { TreeStructure } from "@gsx/common";
@Component({
    components: {
        TreeGroup,
        Loader,
        InlineFormTreeselect,
    },
})
export default class CustomFilter extends Vue {
    @Inject("container") readonly container!: Container;
    @Prop() filterStore!: any;
    @Prop() customTags!: any;

    mounted() {}

    get options() {
        return this.customTags.map((tag: string) => `custom:${tag}`) || [];
    }

    get treeOptions() {
        return this.options.map(
            (tag: string): TreeStructure => ({ id: tag, label: tag.split(":").slice(-1)[0] }),
        );
    }

    toggleTags(customFilterSet: string[]) {
        this.filterStore.customTags = new Set(customFilterSet);
    }

    get filterCount() {
        let count = 0;
        count += this.getCount(this.filterStore.customTags);
        return count;
    }

    getCount(list: Set<any> | undefined) {
        return list ? list.size : 0;
    }
}
